import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    mixins: [reactiveProp],
    extends: Line,
    data: () => ({
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                stepSize: 1
              }
            }
          ]
        }
      }
    }),
  mounted() {
    this.renderLineChart()
  },
  methods: {
    renderLineChart() {
      this.renderChart(this.chartData, this.options)
    }
  }
}




  // import { Line } from 'vue-chartjs'
  // export default {
  //   extends: Line,
  //   props: {
  //     chartData: {
  //       type: Array | Object,
  //       required: false
  //     },
  //     chartLabels: {
  //       type: Array,
  //       required: true
  //     }
  //   },
  //   data () {
  //     return {
  //       options: {
  //         scales: {
  //           yAxes: [{
  //             ticks: {
  //               beginAtZero: true
  //             },
  //             gridLines: {
  //               display: true
  //             }
  //           }],
  //           xAxes: [ {
  //             gridLines: {
  //               display: false
  //             }
  //           }]
  //         },
  //         legend: {
  //           display: false
  //         },
  //         responsive: true,
  //         maintainAspectRatio: false
  //       }
  //     }
  //   },
  //   mounted () {
  //     this.renderChart({
  //       labels: this.chartLabels,
  //       datasets: [
  //         {
  //           label: 'downloads',
  //           borderColor: '#249EBF',
  //           pointBackgroundColor: 'white',
  //           borderWidth: 1,
  //           pointBorderColor: '#249EBF',
  //           backgroundColor: 'transparent',
  //           data: this.chartData
  //         }
  //       ]
  //     }, this.options)
  //   }
  // }


// WEBPACK FOOTER //
// ./src/pages/utils/lineChart.js